
import { Component, Prop, Vue } from 'vue-property-decorator';

/**
 * A small info icon that explains, on hover or keyboard focus, what the
 * figure next to it counts.
 */
@Component({})
export default class InfoTooltipComponent extends Vue {
    @Prop({ required: true })
    public text!: string;
}
